export default function CTA() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20atmospheric%20product%20showcase%20featuring%20a%20curated%20collection%20of%20neutral%20toned%20fashion%20accessories%20and%20lifestyle%20items%20beautifully%20arranged%20on%20a%20textured%20cream%20surface%2C%20soft%20golden%20hour%20backlighting%20creating%20warm%20glow%20and%20gentle%20shadows%2C%20editorial%20catalog%20aesthetic%2C%20rich%20earthy%20tones%20with%20sand%20beige%20and%20warm%20terracotta%20accents%2C%20aspirational%20shopping%20inspiration%20mood%2C%20high%20quality%20commercial%20photography%2C%20elegant%20modern%20composition&width=1920&height=800&seq=kakobuy-cta-bg-v2-01&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          Gotowy, aby odkryć najlepsze produkty?
        </h2>
        <p className="text-white/80 text-lg mb-10 leading-relaxed">
          Przejdź do Kakobuy Spreadsheet i rozpocznij wyszukiwanie już teraz.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-accent-500 hover:bg-accent-600 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Kakobuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-white border border-white/30 hover:border-white/60 hover:bg-white/10 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Kup Teraz
          </a>
        </div>
      </div>
    </section>
  );
}